import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { QuestList } from '../../components/quest-list/quest-list';

import MobileRoomLayout from 'shared/components/layout/mobile-layout';
import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { InfiniteMaxProgressBar } from 'shared/components/ui/progress-bar/progress-bar';
import { RoomFooterText } from 'shared/components/ui/room-footer-text/room-footer-text';
import { ROUTES } from 'shared/constants';
import { useAccount } from 'shared/hooks/use-web3';
import { useQuestsStore } from 'shared/store/questsStore';

export const MobileView: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { items, loading, error, claim, totals, refetch } = useQuestsStore();
  const { isConnected } = useAccount();

  useEffect(() => {
    refetch();
  }, []);

  return (
    <MobileRoomLayout
      title={t('pages.dailyQuests.title')}
      footer={
        isConnected ? (
          <div className="flex h-full w-full flex-col items-center justify-between gap-1">
            <PrimaryButton
              text="pages.dailyQuests.play"
              disabled={false}
              onClick={() => navigate(ROUTES.LOBBY)}
              className="w-full"
              isAnimated
            />
            <RoomFooterText />
          </div>
        ) : (
          <></>
        )
      }
      showFloor={false}
      className="z-50"
    >
      <div className="relative flex h-full w-full flex-col">
        <div className="mx-auto w-full pb-5 pt-2 md:max-w-[375px]">
          <InfiniteMaxProgressBar
            value={Number(totals.bonusPoints ?? 0)}
            className="mb-2"
            showAttention
          />

          {error && (
            <div className="mb-4 rounded-2xl border border-red/40 bg-red/20 px-4 py-3 text-center text-md text-red">
              {error}
            </div>
          )}

          {loading ? (
            <>
              {Array.from({ length: 4 }, (_, index) => (
                <div
                  key={index}
                  className="relative mt-4 flex h-36 w-full min-w-[343px] animate-pulse items-center justify-between gap-6 rounded-xl bg-gray/30 py-4"
                />
              ))}
            </>
          ) : (
            <QuestList
              items={items}
              onClaim={claim}
              pendingTx={totals.txPending}
              loading={loading}
              onRetry={refetch}
            />
          )}
        </div>
      </div>
    </MobileRoomLayout>
  );
};
